export { default as ProductDetailMenu } from "./ProductDetailMenu";
